const messages = {
  'pt-BR': {
    translations: {
      navbar: {
        home: 'Home',
        skill: 'About',
        projects: 'Projects',
        contact: 'Contact',
      },
      footer: {
        copy: 'Copyright 2023. All rights reserved.',
        develop: 'Platform developed by Vinay Reddy.',
      },
      banner: {
        portifolio: 'Welcome to my website!',
        title1: "Hi! I'm Vinay",
        title2: 'Web Developer!',
        descricao: '',
        connect: 'Talk to me!',
      },
      skills: {
        title: 'Skills',
        subtitle:
          'These are some of my skills that I worked on in all my projects as a programmer. Here are inserted both front and back tongues.',
      },
      projects: {
        title: 'Projects',
        subtitle:
          'Here are all my projects, both personal and Hackathon projects. As a programmer, I love updating myself and trying to learn more and more about the most up-to-date technologies on the market to add to my work and my personal development. Here I can show you some of them.',
        modal1: {
          title: 'Voice-Controlled Video Playlister',
          subtitle: 'Voice-Controlled Video Playlister',
          titleContent: 'No touch- use voice commands to watch the videos',
          content:
            'An application that allows users to control the playback of videos using voice commands.The project involves creating a system that can recognize the users voice commands to search and play videos',
          techTitle: 'Technologies used',
          techList: {
            one: 'MongoDB',
            two: 'ExpressJS',
            three: 'React Js',
            four: 'NodeJS',
            five: 'JavaScript',
            six: 'Mongoose',
          },
        },
        modal2: {
          title: 'HealthGenie-(Next-Gen Healthcare Solution)',
          subtitle: 'Healthcare Solution',
          titleContent: 'Makes your health cure at your homes',
          content:
            'This application is an innovative healthcare system that utilizes blockchain, deep learning, and MERN technologies. It features user-friendly functions such as face recognition, appointment scheduling, and a voice assistant,and used Blockchain to prevent data breaches and enhance overall security',
          techTitle: 'Technologies used',
          techList: {
            one: 'BlockChain',
            two: 'ReactJS',
            three: 'Deep Learning',
            four: 'NodeJS',
            five: 'JavaScript',
            six: 'ExpressJS',
          },
        },
        modal3: {
          title: 'Nuclear Shopping Website',
          subtitle: 'Revolutionizing the Online Shopping Experience',
          titleContent: 'Revolutionizing the Online Shopping Experience:',
          content:
            'Introducing a revolutionary new e-commerce platform - the Nuclear Shopping Website. Built with the latest technologies and features, our website offers an unparalleled shopping experience for customers.Customers can create their own user profile, allowing them to easily manage their orders and keep track of their purchase history. Our advanced cart functionality makes adding and removing items from your cart quick and easy. The orders interface allows customers to view their current and past orders, and track their delivery status.The advanced search functionality enables customers to quickly find the products they are looking for, and the user-friendly interface makes navigation a breeze.For the convenience of the merchants, we have built a comprehensive admin dashboard. The admin can add, delete, and update products, view customer details, and track order status. Additionally, the admin can also track the category status and update the footer. We believe that our Nuclear Shopping Website will revolutionize the e-commerce experience, and we are confident that you will find it to be a valuable tool for your shopping needs. Try it today and experience the convenience and ease of shopping online like never before.',
          techTitle: 'Technologies used',
          techList: {
            one: 'MongoDB',
            two: 'ExpressJS',
            three: 'React Js',
            four: 'NodeJS',
            five: 'JavaScript',
            six: 'Mongoose',
          },
        },
      },
      certificate: {
        modal1: {
          title: 'Winner of VIVITSU National Level Hackathon 2K23 ',
          subtitle: 'Ranked 1st position among 200+ teams in Gokaraju College',
        },
        modal2: {
          title: 'Achieved Silver Medal in APJC Netacad Riders-Cisco Exam',
          subtitle: 'Received Silver Medal in All India Level Cisco Exam',
        },
        modal3: {
          title:
            'SemiFinalist of TuringCup Coding Contest conducted by VNR VJIT',
          subtitle: 'Ranked 9th among 500+ teams in VNR VJIT',
        },
        modal4: {
          title:
            'Winner of ELITE HACK CHALLENGE National Level Hackathon 2K23 ',
          subtitle: 'Ranked 1st position among 200+ teams in Anurag University',
        },
        modal5: {
          title: 'Winner of INNOVESIA National level HACKATHON',
          subtitle: 'Ranked 1st position among 320+ teams in Vasavi',
        },
        modal6: {
          title: 'Winner of Hacktoberfest HACKATHON conducted by CBIT',
          subtitle: 'Ranked 1st position among 220 teams in CBIT',
        },
        modal7: {
          title: 'Runner-up of SUDHEE Hackathon',
          subtitle: 'Ranked 2nd out of 190 teams',
        },
        modal8: {
          title: 'Runner-up in Crazy Champs conducted by VJIT',
          subtitle: 'Ranked 2nd among 100+ teams',
          content:
            'Solved questions quickly and accurately within the time limit',
        },
        modal9: {
          title: 'Achieved 3rd position in Codeplay Coding Contest',
          subtitle: 'Ranked 3rd among 1200+ participants',
        },
        modal10: {
          title: 'Participated in ZARC National Level Hackathon in 2021',
          subtitle: ':)',
        },
        modal11: {
          title: 'Winner of Designing a frontend Application',
          subtitle: 'Conducted by Computer Society of India',
        },
        modal12: {
          title: 'Successfully Completed C++ Course by UDEMY ',
          subtitle: 'in 2021',
        },
      },
      contact: {
        title: 'Talk to me!',
        name: 'Your name...',
        email: 'Your email...',
        message: 'Your message...',
        button: 'To send',
      },
      portifolio: {
        title1: 'Click on the button',
        title2: 'and download my resume',
        button: 'Download my resume ;)',
      },
      aboutme: {
        title: 'I am Vinay Reddy',
        subtitle1: 'Web developer',
        subtitle:
          'As a highly motivated and dedicated individual, I am excited to introduce myself as a recent graduate from Vasavi College of Engineering with an aggregate of 9.3 CGPA. My passion for technology has led me to develop a strong set of technical skills, including expertise in c, c++, java, python, data structures, algorithms, OS, HTML, CSS, JavaScript, Bootstrap, ReactJS, MySQL, and Django framework. I am particularly skilled in c++ and the STL (Standard Template Library).In addition to my technical abilities, I am also committed to working collaboratively and building strong team dynamics. I believe that time management and organization are key to the successful completion of any task, and I am always looking for ways to work efficiently and productively.I have experience working as an entrepreneur for both Coding Ninjas and Zuno, and have recently completed projects such as a Publicity Engine and an advanced online shopping application. I have also been recognized for my skills and dedication, having been shortlisted for the Smart India Hackathon 2022, winning the CBIT Hackathon, Hacktober Fest, and Innovesia National Level Hackathon, and being a runner-up in the Code Explorers event organized by my college',
      },
      education: {
        historyTitle: 'My Education',
        title: 'Majoring in Computer Science',
        subtitle: 'Vasavi College of Engineering / 2024 -Batch',
        content:
          'As a student at Vasavi College of Engineering in the Computer Science Department, I am constantly seeking opportunities to expand my knowledge and skills. Through my participation in various hackathons and problem-solving initiatives, I have been able to apply my academic learning to real-world scenarios, further developing my professional abilities. I am committed to continuously challenging myself and taking on new projects to enhance my growth as a computer science professional.',
      },
      personalSkills1: {
        historyTitle: 'My works',
        title: 'Online Shopping Application',
        subtitle: '2022-23',
        content:
          'Introducing a revolutionary new e-commerce platform - the Nuclear Shopping Website. Built with the latest technologies and features, our website offers an unparalleled shopping experience for customers.Customers can create their own user profile, allowing them to easily manage their orders and keep track of their purchase history. Our advanced cart functionality makes adding and removing items from your cart quick and easy. The orders interface allows customers to view their current and past orders, and track their delivery status.The advanced search functionality enables customers to quickly find the products they are looking for, and the user-friendly interface makes navigation a breeze.For the convenience of the merchants, we have built a comprehensive admin dashboard. The admin can add, delete, and update products, view customer details, and track order status. Additionally, the admin can also track the category status and update the footer. We believe that our Nuclear Shopping Website will revolutionize the e-commerce experience, and we are confident that you will find it to be a valuable tool for your shopping needs. Try it today and experience the convenience and ease of shopping online like never before.',
        readLess: 'read less',
        readMore: 'read more',
      },
      personalSkills2: {
        title: 'Publicity Engine',
        subtitle: '2022-23',
        content:
          "Introducing the ultimate search platform for all your content needs - 'Answer at your Fingertips'. Our platform is designed to provide users with quick and easy access to any information they may require. With a user-friendly interface and advanced search capabilities, finding the information you need has never been easier. Whether you are looking for answers to specific questions or simply browsing for new information, our platform has you covered. Experience the convenience of having the information you need at your fingertips - Try 'Answer at your Fingertips' today!",
      },
    },
  },
};

export { messages };
